module.exports = __webpack_public_path__ + "static/fb-share-674f0bd55c1015c4384e9e194df32a3c.jpg";